var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-facebook {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 5.69px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    className: "cls-facebook",
    d: "M43.21,105.39h19.86v-39.7c0-1.08.87-1.95,1.95-1.95h16.95l4.24-17h-22.52c-1.08,0-1.95-.87-1.95-1.95v-8.51c0-7.77,6.29-14.07,14.06-14.08h8.41V5.16h-15.85c-13.89.01-25.14,11.27-25.15,25.15v14.11c0,1.08-.87,1.95-1.95,1.95h-16.92v17.37h16.92c1.07.01,1.94.88,1.95,1.95v39.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookTop);
export default __webpack_public_path__ + "static/media/facebook-top.b77aae38cb8c0b2611653e34f8b82adc.svg";
export { ForwardRef as ReactComponent };